import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOpenInNew = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1408 608V288Q1408 169 1323.5 84.5Q1239 0 1120 0H288Q169 0 84.5 84.5Q0 169 0 288V1120Q0 1239 84.5 1323.5Q169 1408 288 1408H992Q1006 1408 1015.0 1399.0Q1024 1390 1024 1376V1312Q1024 1298 1015.0 1289.0Q1006 1280 992 1280H288Q222 1280 175.0 1233.0Q128 1186 128 1120V288Q128 222 175.0 175.0Q222 128 288 128H1120Q1186 128 1233.0 175.0Q1280 222 1280 288V608Q1280 622 1289.0 631.0Q1298 640 1312 640H1376Q1390 640 1399.0 631.0Q1408 622 1408 608ZM1792 1472V960Q1792 934 1773.0 915.0Q1754 896 1728.0 896.0Q1702 896 1683 915L1507 1091L855 439Q845 429 832.0 429.0Q819 429 809 439L695 553Q685 563 685.0 576.0Q685 589 695 599L1347 1251L1171 1427Q1152 1446 1152.0 1472.0Q1152 1498 1171.0 1517.0Q1190 1536 1216 1536H1728Q1754 1536 1773.0 1517.0Q1792 1498 1792 1472Z"
	})
});
export default SvgOpenInNew;
